/**
 * Каким полем ученик отвечает на вопрос задания пула (техдолг 440, 26.10.2026).
 *
 * ⚠️ ЗАЧЕМ ОТДЕЛЬНО. Мок (LegacyTaskCard) рисовал TRUE/FALSE/NOT GIVEN кнопками, а
 * тренажёр (IeltsTrainerPage) — полем ввода: сервер отдаёт эти вопросы без вариантов,
 * и тренажёр выбирал виджет по наличию вариантов, а не по виду. Ученик печатал
 * «Not Given», ключ — «not_given», верный ответ шёл в неверные. Виды с общим списком
 * (заголовки, особенности, окончания, банк фраз) тоже требовали набрать вариант целиком.
 * Теперь виджет выбирается по виду в одном месте — и мок, и тренажёр.
 */
import { hasBlockOptions } from '../api/ieltsMock';

export type AnswerWidget = 'closed' | 'single' | 'multi' | 'select' | 'text';

/** Значения — ровно как ключи сервера (`ielts_pool_validate.go`); подписи — как в бланке IELTS. */
export const CLOSED_CHOICES: Record<string, ReadonlyArray<readonly [string, string]>> = {
  true_false_ng: [
    ['true', 'True'],
    ['false', 'False'],
    ['not_given', 'Not Given'],
  ],
  yes_no_ng: [
    ['yes', 'Yes'],
    ['no', 'No'],
    ['not_given', 'Not Given'],
  ],
};

/**
 * questionOptions — вариантов у самого вопроса, sharedOptions — в общем списке задания.
 */
export function answerWidget(type: string, questionOptions: number, sharedOptions: number): AnswerWidget {
  if (CLOSED_CHOICES[type]) return 'closed';
  if (questionOptions > 0) return type === 'mc_multi' ? 'multi' : 'single';
  if (sharedOptions > 0 && hasBlockOptions(type)) return 'select';
  return 'text';
}

const BANK_LETTERS = 'ABCDEFGHIJKLMNOP';

/**
 * Подпись варианта общего списка с буквой, как в моке (LegacyTaskCard) и на бланке: «A. Morning session».
 * Инструкция matching в Listening называет буквы («Write the correct letter, A, B or C», 27.10.2026) —
 * без букв в тренажёре ученику не к чему её приложить. Вариант, который сам буква («C» у сопоставления
 * с абзацами), — без повтора. Значение ответа — по-прежнему текст варианта.
 */
export function bankLabel(index: number, text: string): string {
  const letter = BANK_LETTERS[index] ?? '';
  if (!letter || text.trim().toUpperCase() === letter) return text;
  return `${letter}. ${text}`;
}
